import axios, { AxiosHeaders } from "axios";
import { makeUseAxios } from "axios-hooks";
import cookie from "js-cookie";

const baseURL = process.env.REACT_APP_API_URL;

const API = axios.create({ baseURL });

API.interceptors.request.use(
  function (config) {
    const csrfToken = cookie.get("csrftoken") || "";
    return {
      ...config,
      headers: new AxiosHeaders({ ...config.headers, "X-CSRFToken": csrfToken }),
    };
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default API;

export const useRequest = makeUseAxios({ axios: API });
